import React from 'react';
import { useTranslation } from 'react-i18next';

import { Status } from '@weezevent/nacre';

import { InfoTextTooltip } from '../../../../attendee/detail/components/infotext-tooltip/infoTextTooltip';

import css from './components.module.css';

const ActionOption = ({ action }) => {
    const { t } = useTranslation();
    return (
        <div className={css['action-select-options']}>
            <InfoTextTooltip
                title={action.name}
                subtitle={
                    <span>
                        {`${t('ticket.common.type')}: `}
                        {t(`ticket.moderation.statusesTransitions.transition.steps.actions.${action.type}`)}
                    </span>
                }
            />
            <div>
                <Status responsive text={t(`ticket.moderation.statusesTransitions.actionsTable.status_${action.status}`)} color={action.status_color} />
            </div>
        </div>
    );
};

export default ActionOption;
